const name = "bundlephobia-mcp";
const version = "0.2.9";

const TOOL_TITLE = "Bundlephobia MCP";
const TOOL_DESCRIPTION = "Allow your AI to consider the bundle size and tree-shakeability of npm packages.";
const PKG_NAME = name;
const PKG_VERSION = version;

export { PKG_NAME, PKG_VERSION, TOOL_DESCRIPTION, TOOL_TITLE };
